import React from 'react';
import { breakpoints, columns, gap } from '../gridSettings';
export const Col = ({ children, className = '', xs = 0, sm = 0, md = 0, lg = 0, xl = 0, gutter = gap, gutterY = 0, width = 0, }) => (<>
    <div className={`bl-haven-col ${className}`}>{children}</div>
    <style global jsx>
      {`
        .bl-haven-col {
          box-sizing: border-box;
          flex-grow: 1;
          flex-shrink: 1;
          flex-basis: 0;
        }
      `}
    </style>
    <style jsx>
      {`
        .bl-haven-col {
          ${width > 0
        ? `
              flex-basis: ${width + gutter}px;
              flex-grow: 0;
              flex-shrink: 0;
            `
        : ''}
          ${xs > 0
        ? `
              flex-basis: ${(xs * 100) / columns}%;
              max-width: ${(xs * 100) / columns}%;
            `
        : ''}
          ${gutterY > 0
        ? `
            padding-top: ${gutterY > 0 ? `${gutterY / 2}px` : 0};
            padding-bottom: ${gutterY > 0 ? `${gutterY / 2}px` : 0};
            `
        : ''}
          padding-right: ${gutter > 0 ? `${gutter / 2}px` : 0};
          padding-left: ${gutter > 0 ? `${gutter / 2}px` : 0};
        }

        @media (min-width: ${breakpoints.sm}px) {
          .bl-haven-col {
            ${sm > 0
        ? `
                flex-basis: ${(sm * 100) / columns}%;
                max-width: ${(sm * 100) / columns}%;
              `
        : ''}
          }
        }

        @media (min-width: ${breakpoints.md}px) {
          .bl-haven-col {
            ${md > 0
        ? `
                flex-basis: ${(md * 100) / columns}%;
                max-width: ${(md * 100) / columns}%;
              `
        : ''}
          }
        }

        @media (min-width: ${breakpoints.lg}px) {
          .bl-haven-col {
            ${lg > 0
        ? `
                flex-basis: ${(lg * 100) / columns}%;
                max-width: ${(lg * 100) / columns}%;
              `
        : ''}
          }
        }

        @media (min-width: ${breakpoints.xl}px) {
          .bl-haven-col {
            ${xl > 0
        ? `
                flex-basis: ${(xl * 100) / columns}%;
                max-width: ${(xl * 100) / columns}%;
              `
        : ''}
          }
        }
      `}
    </style>
  </>);
